import update from 'immutability-helper';
import * as types from './types';

export interface IState {
  expandEvents: string[];
  highlights: {
    [key: string]: number;
  }
}

const initialState: IState = {
  expandEvents: [],
  highlights: {},
};

const switchMap: {
  [key in keyof typeof types]?: (
    state: IState,
    action: Partial<{ type: keyof typeof types }>,
  ) => string;
} = {};

switchMap[types.INIT] = state =>
  update(state, {
    $set: initialState,
  });

switchMap[types.ON_EXPAND_EVENT] = (state: IState, action) => {
  const expandEvents = new Set(state.expandEvents);
  const { toggle, event } = action;
  // Delete from the array if there is
  if (expandEvents.has(event) && toggle) {
    expandEvents.delete(event);
    return update(state, {
      expandEvents: {
        $set: Array.from(expandEvents),
      },
    });
  }
  // Add to the array if not
  expandEvents.add(event);
  return update(state, {
    expandEvents: {
      $set: Array.from(expandEvents),
    },
  });
};

switchMap[types.HIGHLIGHT_MOMENT_BY_EVENT] = (state: IState, action) => {
  const { highlights } = state;
  return update(state, {
    highlights: {
      $set: update(highlights, {
        [action.event]: {
          $set: action.timestamp,
        }
      })
    }
  });
};

switchMap[types.REMOVE_HIGHLIGHT_BY_EVENT] = (state: IState, action) => {
  const { highlights } = state;
  if (!highlights[action.event]) {
    return state;
  }
  delete highlights[action.event];
  return update(state, {
    highlights: {
      $set: {
        ...highlights,
      },
    },
  });
}

switchMap[types.APPLY_TIMELINE_UI] = (state: IState, action) =>
  update(state, { $merge: action.ui });

export default (state = initialState, action) =>
  switchMap[action.type] ? switchMap[action.type](state, action) : state;
